<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm04_cont"><a id="page_v"></a><strong>Contents</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm05_fore#ch00_fm05_fore"><em>Foreword by Emilio Pardo</em></a></p>
<p class="toc1"><a class="nounder" href="#/xhtml/ch00_fm06_intro#ch00_fm06_intro">Introduction Your Life Reimagined Journey</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch01#ch01" title="Link target outside of Sample">Chapter 1 This Isn’t What I Was Expecting!</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">Chapter 2 Get Real</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">Chapter 3 What Works?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Chapter 4 Reflect—What’s Real for You?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Chapter 5 Connect—Who’s There for You?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">Chapter 6 Explore—What’s Possible for You?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Chapter 7 Take a Break—Whew!</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">Chapter 8 Choose—What’s Next?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">Chapter 9 Repack—What To Lose, What To Take?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">Chapter 10 Act—What To Do Now?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">Chapter 11 Take a Break—Is It Over Yet?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">Chapter 12 Is This Your Life Reimagined Moment?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">Chapter 13 It’s Your Move</span></p>
<p class="toc3"><span class="nounder" href="#/xhtml/ch14_life#ch14_life" title="Link target outside of Sample">Life Reimagined Conversations</span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch15_ack#ch15_ack" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch16_inter#ch16_inter" title="Link target outside of Sample"><em>Interviews with the Authors</em></span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch17_life1#ch17_life1" title="Link target outside of Sample"><em>Life Reimagined Resources</em></span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch18_index#ch18_index" title="Link target outside of Sample"><em>Index</em></span><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_cont.vue?84801bd2